import constants from './app.constants';
import events from './appEvents.constant';
import previousSearchCount from './previous-search-count';
import commonCurrency from './commonCurrency';
const MODULE_NAME = 'app.constants';

const module = angular.module(MODULE_NAME, [])
    .constant('appCONST', constants)
    .constant('appEvents', events)
    .constant('commonCurrency', commonCurrency)
    .constant('PREVIOUS_SEARCH_COUNT', previousSearchCount);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/constants/constants-module.js